import ResultItem from '../../Components/ResultItem/ResultItem'
import { notReady } from '../../Redux/Features/Quiz/quizStateSlice'
import { useEffect } from 'react'
import { Questions } from '../../questions'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import './Result.css'

const Result = () => {
  const quiz_state = useSelector((state) => state.quiz.value)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const calculateResult = () => {
    let score = 0

    Questions.map((section) =>
      section.questions.map((question) => {
        if (
          question.answer ===
          JSON.parse(localStorage.getItem('result'))[question.id].option
        ) {
          score++
        }
      })
    )
    return score
  }

  const reQuiz = () => {
    dispatch(notReady())
    localStorage.removeItem('result')
    navigate('/')
  }

  useEffect(() => {
    if (quiz_state === 'not-ready') navigate('/')
  }, [])

  return (
    <div className='mw-1340'>
      <div className='result__container'>
        <div className='result__container__info'>
          <div>
            {calculateResult() >= 48 ? (
              <h1 style={{ color: 'green' }}>
                Вітаємо! Ви успішно пройшли тестування
              </h1>
            ) : (
              <h1 style={{ color: 'red' }}>
                На жаль, ви не набрали достатню кількість балів
              </h1>
            )}
            <h3>Кількість набраних балів: {calculateResult()} із 60</h3>
            <Link to='/' onClick={reQuiz}>
              Пройти заново
            </Link>
          </div>
        </div>
        <div className='result__container__items'>
          {Questions.map((item) =>
            item.questions.map((question) => (
              <ResultItem
                question_title={question.prompt}
                option_a={question.option_a}
                option_b={question.option_b}
                option_c={question.option_c}
                option_d={question.option_d}
                answer={question.answer}
                chosen_option={
                  JSON.parse(localStorage.getItem('result'))[question.id].option
                }
                key={question.id}
              />
            ))
          )}
        </div>
      </div>
    </div>
  )
}

export default Result
